export const feedbackOptions = [
  "Help & support request",
  "Feature request",
  "Bug report",
  "API improvement suggestion",
  "Website improvement suggestion",
  "IRIS improvement suggestion",
];
